var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBanner)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('b-alert',{attrs:{"show":""}},[_vm._v(_vm._s(_vm.bannerText))])],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }